import React, {useEffect, useState} from 'react'
import {getCardDescriptionById} from '../services/cards'

const useGetDescription = (
  id: string
): {
  fetchDescription: () => void
  cardDescription: null | string
  setCardDescription: React.Dispatch<React.SetStateAction<null | string>>
  isCardDescriptionLoading: boolean
  cardIdForDesc:null | string
  initialDesc:string | null
  card:any
} => {
  const [cardDescription, setCardDescription] = useState<null | string>(null)
  const [initialDesc, setInitialDesc] = useState<null | string>(null)
  const [cardIdForDesc, setCardIdForDesc] = useState<null | string>(null)
  const [card, setCard] = useState<null | any>(null)
  const [isCardDescriptionLoading, setCardDescriptionLoading] = useState<boolean>(false)

  const fetchDescription = async () => {
    try {
      setCardDescriptionLoading(true)
      const res = await getCardDescriptionById(id)
      const descData = res.data.data.card
      if (descData) {
        setCardDescription(descData.description)
        setInitialDesc(descData.description)
        setCardIdForDesc(descData.id)
        setCard(res.data.data.card)
      }
    } catch (error: any) {
      return error
    } finally {
      setCardDescriptionLoading(false)
    }
  }

  useEffect(() => {
    fetchDescription()
    //eslint-disable-next-line
  }, [id])

  return {cardDescription, isCardDescriptionLoading, setCardDescription,fetchDescription,cardIdForDesc,initialDesc,card}
}

export default useGetDescription
